module.exports = __webpack_public_path__ + "img/flag_of_the_united_states.19ae0a50.svg";